<template>
  <div class="Edit">
    <el-form ref="datas" :model="datas" hide-required-asterisk label-width="100px" :rules="rules">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="datas.roleName" />
      </el-form-item>
      <el-form-item label="是否启用">
        <el-radio-group v-model="datas.status">
          <el-radio :disabled="isdisabled" :label="true">启用</el-radio>
          <el-radio :disabled="isdisabled" :label="false">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Role from "@/api/RoleModule";
export default {
  data() {
    return {
      datas: {},
       menus:[
                {
                    level1Menu:'我的资料',
                    isActive:true,
                    level2Page:[
                        {
                            menuName:"个人中心",
                            isActive:true,//是否选中
                        }
                    ]
                },
                {
                    level1Menu:'数据中心',
                    isActive:true,
                    level2Page:[
                        {
                            menuName:"基础数据",
                            isActive:true,//是否选中
                        }
                    ]
                },
                {
                    level1Menu:'职位管理',
                    isActive:true,
                    level2Page:[
                        {
                            menuName:"职位列表",
                            isActive:true,
                        }
                    ]
                },
                {
                    level1Menu:'简历管理',
                    isActive:true,
                    level2Page:[
                        {
                            menuName:"人才搜索",
                            isActive:true,
                        },
                        {
                            menuName:"简历列表",
                            isActive:true,
                        },
                    ]
                },
                {
                    level1Menu:'权限与账号',
                    isActive:true,
                    level2Page:[
                        {
                            menuName:"角色权限",
                            isActive:true,
                        },
                        {
                            menuName:"账号管理",
                            isActive:true,
                        }
                    ]
                }
            ],
      rules: {
        roleName: {
          required: true,
          validator: this.validateRole,
          trigger: "blur"
        }
      }
    };
  },
  props: {
    roleData: Object,
    dialogType: String,
    isdisabled: Boolean
  },
  watch: {},
  methods: {
    Submission(el) {
      this.$refs[el].validate(valid => {
        if (valid) {
          if(this.datas.status){
            if(!this.datas.roleDetail.length){
              this.datas.roleDetail=this.menus;
            }
          }else{
            this.datas.roleDetail = [];
          }
          this.$emit("datamaseg", this.datas, this.dialogType, true);
        } else {
          this.$emit("datamaseg", {}, this.dialogType, false);
          return false;
        }
      });
    },
    accountReg(el){
      this.datas.roleName = null;
      this.$refs[el].validateField('roleName');
    },
    validateRole(rule, value, callback) {
      var datas = `search=${value}`;
      if (!value) {
        if(value===null){
          callback(new Error("该角色已存在"));
        }else{
          callback(new Error("角色名称不能为空"));
        }
      } else {
        callback();
        // if(this.dialogType === 'new'){
        //   Role.searchRoleList(datas) //
        //   .then(res => {
        //     if (res.data.data && res.data.data.length) {
        //       callback(new Error("该角色已存在"));
        //     } else {
        //       callback();
        //     }
        //   })
        //   .catch(err => {
        //     console.log(err);
        //   });
        // }else{
        //   callback();
        // }
      }
    }
  },
  mounted() {
    var that = this;
    if (JSON.stringify(this.roleData) === "{}") {
      this.datas = {
        roleName: "",
        roleDetail: [],
        status: true
      };
    } else {
      Role.getRoleItem(this.roleData.id) //
        .then(res => {
          var resData = res.data.data;
          that.datas = {
            roleName: resData.role_name,
            roleDetail: resData.role_detail,
            id: resData.id,
            status: resData.active_status
          };
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style>
.Edit {
  padding: 40px 0 0 45px!important;
}
.Edit .el-message-box__content {
  text-align: left!important;
  padding: 40px 15px 10px!important;
}
.Edit .el-form-item__label {
  line-height: 34px!important;
  color: #666666!important;
}
.Edit .el-form-item__content,
.el-input__inner {
  height: 34px!important;
  line-height: 34px!important;
}
.Edit .el-input {
  width: 220px!important;
}
.Edit .required {
  color: #ff1935!important;
}
.Edit .el-select {
  width: auto !important;
}
.Edit .el-input__icon {
  line-height: 34px!important;
}
</style>


// WEBPACK FOOTER //
// src/views/role/components/edit.vue